import React, { useState } from "react";
import { forgotPassword } from "../api/authApi";
import "./Auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError(false);
    try {
      await forgotPassword(email);
      // Generic message for security
      setMsg(
        "If an account with this email exists, you will receive a password reset link."
      );
    } catch (err) {
      setMsg("Error sending reset link. Please try again later.");
      setError(true);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Forgot Password</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="auth-btn">
            Send Reset Link
          </button>
        </form>
        {msg && (
          <p className={`auth-msg ${error ? "error" : "success"}`}>{msg}</p>
        )}
      </div>
    </div>
  );
}
